var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 9.5H15.0833V3C15.0833 2.75 14.8333 2.5 14.5833 2.5H5.58331C5.30206 2.5 5.08331 2.75 5.08331 3V9.5H0.583313C0.302063 9.5 0.083313 9.75 0.083313 10V18C0.083313 18.2812 0.302063 18.5 0.583313 18.5H19.5833C19.8333 18.5 20.0833 18.2812 20.0833 18V10C20.0833 9.75 19.8333 9.5 19.5833 9.5ZM14.0833 10.5H16.0833V12.4688L15.0833 12.125L14.0833 12.4688V10.5ZM11.0833 3.5V5.46875L10.0833 5.125L9.08331 5.46875V3.5H11.0833ZM6.08331 3.5H8.08331V6.84375L10.0833 6.1875L12.0833 6.84375V3.5H14.0833V9.5H6.08331V3.5ZM6.08331 10.5V12.4688L5.08331 12.125L4.08331 12.4688V10.5H6.08331ZM1.08331 10.5H3.08331V13.8438L5.08331 13.1875L7.08331 13.8438V10.5H9.58331V17.5H1.08331V10.5ZM19.0833 17.5H10.5833V10.5H13.0833V13.8438L15.0833 13.1875L17.0833 13.8438V10.5H19.0833V17.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.1e8655b8.svg";
export { ForwardRef as ReactComponent };